var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_24)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.1602,
    y: 17.9199,
    width: 41.6,
    height: 28.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6602 38.5179L38.5242 31.9999L27.6602 25.4819V38.5179Z",
    fill: "#C65707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 0C14.328 0 0 14.326 0 32C0 49.674 14.328 64 32 64C49.672 64 64 49.672 64 32C64 14.328 49.672 0 32 0ZM49.376 33.402C49.376 36.402 49.028 39.402 49.028 39.402C49.028 39.402 48.688 41.958 47.648 43.08C46.326 44.556 44.846 44.564 44.166 44.652C39.302 45.024 32 45.036 32 45.036C32 45.036 22.964 44.948 20.184 44.664C19.41 44.51 17.676 44.554 16.352 43.08C15.31 41.956 14.972 39.402 14.972 39.402C14.972 39.402 14.624 36.404 14.624 33.402V30.59C14.624 27.59 14.972 24.592 14.972 24.592C14.972 24.592 15.312 22.036 16.352 20.91C17.674 19.432 19.154 19.424 19.834 19.34C24.696 18.964 31.992 18.964 31.992 18.964H32.008C32.008 18.964 39.304 18.964 44.166 19.34C44.844 19.424 46.326 19.432 47.648 20.908C48.69 22.034 49.028 24.59 49.028 24.59C49.028 24.59 49.376 27.59 49.376 30.59V33.402Z",
    fill: "#C65707"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.122324972464c798b182603771bb22dc.svg";
export { ForwardRef as ReactComponent };